<template>

    <Layout>
      <Card>
        <p slot="title">消息管理</p>
        <div class="search-box">
          <Input
            v-model="input"
            placeholder="按手机号查询"
            search
            enter-button="搜索"
            :style="{ width: '250px' }"
            @on-search="loadData"
          />
          <div style="width:20px;"/>
          <el-select v-if='user.isXTGLY()' v-model="type.type" size="small" @change="typeChange" clearable placeholder="请选择角色">
              <el-option
                v-for="item in type.items"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
          </el-select>
        </div>
       <div class="content">
        <el-table :data="tableData">
          <el-table-column prop="id" align="center" minWidth="150" :label="team.label+'ID'"></el-table-column>
          <el-table-column prop="name" align="center" minWidth="150" :label="team.label+'姓名'"></el-table-column>
          <el-table-column prop="mobile" align="center" minWidth="150" label="手机号"></el-table-column>
          <el-table-column prop="sex" align="center" minWidth="120" label="性别">
            <template slot-scope="scope">
              {{user.sexMap[scope.row.sex]}}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="birth" minWidth="150" label="出生日期"></el-table-column>
          <el-table-column align="center" minWidth="200" v-if='user.isXTGLY()' prop="teamName" label="绑定团队"></el-table-column>
          <el-table-column align="center" minWidth="120" prop="avatar" label="头像">
            <template slot-scope="scope">
              <img class="avatar" :src="scope.row.avatar" />
            </template>
          </el-table-column>

          <el-table-column align="center" minWidth="120" prop="status" label="操作">
            <template slot-scope="{ row }">
            <Button style="margin-left:5px;" @click="showAction(row)">查看</Button>
            </template>
          </el-table-column>

        </el-table>
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="pagenum"
          @current-change="handleCurrentChange"
          :total="total"
        ></el-pagination>
      </div>
      </Card>
      
      <messageDialog @close="dialogClose" :readOnly="true" :visible="dialog.visible" :doctorId="dialog.doctorId"/>
    </Layout>
</template>
<script>
import messageDialog from "./messageDialog.vue";
export default {

  components: {
   messageDialog
  },
  data() {
    return {
      total: 10,
      pagenum: 1,
      status,
      pagesize: 10,
      input: "",
      tableData: [],
      actionColumns:[],
      changeDoctor:null,
      team:{
       label:''
      },
      dialog:{
        visible:false,
        doctorId:null,
      },
      type:{
        value:null,
        items:[
          {value:'1',label:this.user.doctorTypeE.JGS},
          {value:'2',label:this.user.doctorTypeE.ZXS}
        ]
      }
      
    };
  },
  mounted(){

  },
  created() {

    var that=this;
    that.init();
    that.loadData();

  },
  methods: {
    init(){
      if(this.user.isXTGLY())
      {
        this.type.value=1;
      }
      else if(this.user.isTDD())
      {
        this.team.label=this.user.doctorTypeE.JGS_S;
      }
      else if(this.user.isTDD())
      {
        this.team.label=this.user.doctorTypeE.ZXS_S;
      }
      this.typeInit();
    },
    typeInit(){
      if(this.type.value==1)
      {
        this.team.label=this.user.doctorTypeE.JGS_S;
      }
      else if(this.type.value==2){
        this.team.label=this.user.doctorTypeE.ZXS_S;
      }
    },
    typeChange(value){
      if(value==-1)
      {
        this.type.value='';
      }
      else{
        this.type.value=value;
      }
      this.typeInit();
      this.loadData();
    },
    showAction(row){
      this.dialog.doctorId=row.id;
      this.dialog.visible=true;
    },
    dialogClose(){
      this.dialog.visible=false;
      this.dialog.doctorId=null;
    },
    loadData() {
      //列表
      var that = this;
      var parameter = {
        mobile: that.input,
        page: that.pagenum,
        pageSize: that.pagesize,
        type:that.type.value,
        interfaceType:that.user.interfaceTypeMapE.MSG
      };
      that.api.doctorQueryList(parameter).then((response) => {
        response = response.data;
        that.total = response.totalCount;
        that.tableData = response.list;
      });
    },
    handleCurrentChange(cpage) {
      //分页
      this.pagenum = cpage;
      this.loadData();
    },
  },
};
</script>
<style lang="less" scoped="scoped">
.content img {
  width: 40px;
}
.search-box {
  display: flex;
align-items: center;
}
/deep/.ivu-btn
{
  padding:5px;
}
/deep/.el-table td.el-table__cell div
{
  display: flex;
    align-items: center;
    justify-content:center;
}

/deep/.ivu-input-search
{
background: #185AD6 !important;
border-radius: 2px;
}

</style>
